import { Data, Model, Utils } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import CommandResult from "../../Common/Models/CommandResult";
import { AppService, Types } from '../../App/Services/AppService';
import StaticEventLookup from '../../DataInterception/EventMapping/Models/StaticEventSearchModal/StaticEventLookup';
import CreateStaticEventCommand from '../StaticEvents/Models/Commands/CreateStaticEventCommand';
import UpdateStaticEventCommand from '../StaticEvents/Models/Commands/UpdateStaticEventCommand';
import EventSearchCriteria from '../../DataInterception/EventMapping/Models/EventSearchCriteria';

export interface IStaticEventsApiClient {
    getPagedStaticEvents(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<EventSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<StaticEventLookup>>>;
    getEventLookupListByCriteria(criteria?: string): AxiosPromise<Array<Model.PlainObject<StaticEventLookup>>>;
    createStaticEvent(command: Model.PlainObject<CreateStaticEventCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    updateStaticEvent(command: Model.PlainObject<UpdateStaticEventCommand>): AxiosPromise<Model.PlainObject<CommandResult>>;
    getEventLookupByID(criteria: number): AxiosPromise<Model.PlainObject<StaticEventLookup>>;
    getEventLookupFromEventName(criteria: string): AxiosPromise<Model.PlainObject<StaticEventLookup>>;
}

@injectable()
export default class StaticEventsApiClient extends Data.ApiClientBase implements IStaticEventsApiClient {

    constructor(config = AppService.get(Types.Config)) {
        super(`${config.apiPath}/StaticEvent`)
    }

    public getPagedStaticEvents(payload: Model.PartialPlainNonTrackedObject<Data.PageRequest<EventSearchCriteria>>): AxiosPromise<Data.PageResult<Model.PlainObject<StaticEventLookup>>> {
        return this.axios.get(`${this.apiPath}/GetStaticEventLookup?${Utils.getQueryString(payload)}`);
    }

    public createStaticEvent(command: Model.PlainObject<CreateStaticEventCommand>): AxiosPromise<Model.PlainObject<CommandResult>>{
        return this.axios.post(`${this.apiPath}/CreateStaticEvent`, command);
    }

    public updateStaticEvent(command: Model.PlainObject<UpdateStaticEventCommand>): AxiosPromise<Model.PlainObject<CommandResult>>{
        return this.axios.post(`${this.apiPath}/UpdateStaticEvent`, command);
    }

    public getEventLookupListByCriteria(criteria: string = ""): AxiosPromise<Array<Model.PlainObject<StaticEventLookup>>> {
        return this.axios.get(`${this.apiPath}/GetEventLookupListByCriteria`, { params: { criteria: criteria } });
    }

    public getEventLookupByID(staticEventID: number): AxiosPromise<Model.PlainObject<StaticEventLookup>> {
        return this.axios.get(`${this.apiPath}/GetEventLookupByID`, { params: { staticEventID: staticEventID }});
    }

    public getEventLookupFromEventName(criteria: string): AxiosPromise<Model.PlainObject<StaticEventLookup>> {
        return this.axios.get(`${this.apiPath}/GetEventLookupFromEventName`, { params: {eventName: criteria}});
    }
}